import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt";
import LocationContent from "../components/main/LocationContent";
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import BookingForm from "../components/form/BookingForm";
import OurLocation from "../components/OurLocation";
import PopupOffer from "../components/PopupOffer";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const GurugramPage = () => {
  const [openForm, setOpenForm] = useState(false);

  const [offerPopup, setOfferPopup] = useState(false);

  const [petGroom, setPetGroom] = useState("Dog");

  useEffect(() => {
    const timer = setTimeout(() => {
      setOfferPopup(true);
    }, 15000);

    return () => clearInterval(timer);
  }, []);

  const headerData = {
    heading: "Professional Pet Grooming at Home in Gurugram",
    text: "Same Day Booking - Smart Choice for Gurugram Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [
      {
        question: "Why Gurgaon’s Pet Parents Trust Us?",
        text: [
          "✔ Zero Stress for Pets: No car rides, no cage drying—just a relaxed grooming session where your pet feels safest.",
          "✔ Breed Experts: From fluffy Huskies to finicky Maine Coons, we know how to handle every coat and personality.",
          "✔ Safe & Spotless: We use pH-balanced shampoos, sanitized tools, and lots of patience.",
        ],
        points: [],
      },
      {
        question: "Which areas of Gurugram do you cover?",
        text: [
          "✅ Full coverage: DLF Phases 1-5, Sushant Lok (Blocks A-E), Palam Vihar, Golf Course Road, Sectors 56-57. Pre-approved entry in societies like The Crest and DLF Aralias.",
        ],
        points: [],
      },
      {
        question: "Can you service gated communities after hours?",
        text: [
          "🕘 Yes! We coordinate with security in DLF/Sushant Lok till 10 PM. Share gate pass details during booking.",
        ],
        points: [],
      },
      {
        question: "What’s included in the ₹899 Basic Grooming?",
        text: ["🛁 Full service:"],
        points: [
          "Medicated bath (pH-balanced for Gurugram water)",
          "Nail trim + ear cleaning",
          "Light brushing",
          "Add-ons: Teeth cleaning (+₹200), Paw balm (+₹150)",
        ],
      },
      {
        question: "Why is home grooming cheaper than South Delhi salons?",
        text: ["📉 No hidden costs:"],
        points: [
          "Zero travel fees within Gurugram",
          "No salon rental overheads",
          "Bulk discounts on premium products",
        ],
      },
      {
        question: "Do you handle aggressive breeds like Rottweilers or GSDs?",
        text: ["🐺 Certified expertise:"],
        points: [
          "Muzzle-trained groomers",
          "Slow desensitization techniques",
          "Emergency protocols in place",
        ],
      },
      {
        question: "My Persian cat gets severe mats. Can you help?",
        text: ["🐱 Specialized care:"],
        points: [
          "Painless detangling sprays",
          "Lion cuts for extreme matting",
          "Calming pheromones used",
        ],
      },
      {
        question: "What if my pet gets injured during grooming?",
        text: ["🩹 Safety first:"],
        points: [
          "Pet first-aid certified team",
          "Sterilized tools for each session",
          "Immediate vet contact on file",
        ],
      },
      {
        question: "What should I prepare at home?",
        text: ["🧴 Just 3 things:"],
        points: [
          "Power outlet (for clippers)",
          "Old towels",
          "Vaccination records (for puppies)",
        ],
      },
      {
        question: "Can I get same-day service in Sector 56?",
        text: ["⏱️ 3-hour slots:"],
        points: [
          "Book by 8 AM for afternoon slots",
          "Last-minute fee: +₹200 (after 6 PM)",
        ],
      },
      {
        question: "What payment methods do you accept?",
        text: ["💳 All options:"],
        points: [
          "UPI (PhonePe/Gpay)",
          "Credit/debit cards (POS available)",
          "Corporate invoices (for bulk bookings)",
        ],
      },
    ],
  };

  const locationData = {
    data: [
      "Sector 1–57",
      "Sector 58–67",
      "Sector 68–75",
      "Sector 76–95",
      "Sector 99–115",
      "Sector 4",
      "Sector 10",
      "Sector 23",
      "Sector 40",
      "Sector 63",
      "DLF Phase 1",
      "DLF Phase 2",
      "DLF Phase 3",
      "Sushant Lok I",
      "Sushant Lok II",
      "South City 1",
      "South City 2",
      "Nirvana Country",
      "Malibu Towne",
      "Golf Course Road",
      "Cyber City",
      "Udyog Vihar",
      "MG Road",
      "Sohna Road",
      "Sector 29",
      "Dwarka Expressway",
      "SPR",
      "New Gurgaon",
      "Manesar",
      "Badshahpur",
      "Wazirabad",
      "Palam Vihar",
      "Bhondsi",
      "Gwal Pahari",
      "Kadarpur",
      "Sikanderpur",
      "Basai",
    ],
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Pet Grooming at Home",
    provider: {
      "@type": "LocalBusiness",
      name: "FluffyTouch",
      image: "https://fluffytouch.in/logo.png",
      url: "https://fluffytouch.in/pet-grooming-at-home/gurugram",
      telephone: "+91-9658189189",
      priceRange: "₹899 - ₹1799",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Gurugram",
        addressRegion: "HR",
        addressCountry: "IN",
      },
      areaServed: [
        "Sector 1–57",
        "Sector 58–67",
        "Sector 68–75",
        "Sector 76–95",
        "Sector 99–115",
        "Sector 4",
        "Sector 10",
        "Sector 23",
        "Sector 40",
        "Sector 63",
        "DLF Phase 1",
        "DLF Phase 2",
        "DLF Phase 3",
        "Sushant Lok I",
        "Sushant Lok II",
        "South City 1",
        "South City 2",
        "Nirvana Country",
        "Malibu Towne",
        "Golf Course Road",
        "Cyber City",
        "Udyog Vihar",
        "MG Road",
        "Sohna Road",
        "Sector 29",
        "Dwarka Expressway",
        "SPR",
        "New Gurgaon",
        "Manesar",
        "Badshahpur",
        "Wazirabad",
        "Palam Vihar",
        "Bhondsi",
        "Gwal Pahari",
        "Kadarpur",
        "Sikanderpur",
        "Basai",
      ],
      openingHours: "Mo-Su 06:30-22:00",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Gurugram Pet Grooming Packages",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Essential Grooming",
            description:
              "Medicated bath, nail trimming, ear cleaning, light brushing",
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: "899",
            },
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Luxury Spa Experience",
            description:
              "Breed-specific styling, deep conditioning, dental care",
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: "1799",
            },
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Medical Add-Ons",
            description:
              "Flea treatment, post-surgery care, senior pet specials",
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: "300+",
            },
          },
        },
      ],
    },
    availableChannel: {
      "@type": "ServiceChannel",
      serviceLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Gurugram",
          addressRegion: "HR",
          addressCountry: "IN",
        },
      },
    },
    validFrom: "2024-01-01",
    validThrough: "2025-09-08",
  };

  return (
    <div>
      <div className="gurugram-page">
        <Helmet>
          <title>Same-Day Mobile Pet Grooming in Gurugram | At Your Home</title>
          <meta
            name="description"
            content="
          Certified mobile groomers serving DLF, Sushant Lok. Stress-free pampering at home. Book now for a happy, clean pet!
        "
          />
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>

        {openForm ? <BookingForm setOpenForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav />

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

        <LocationGroomingPackageComponent
          petGroom={petGroom}
          setPetGroom={setPetGroom}
        />

        <LocationComponent location="Gurgaon" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContent />

        <OurLocation />

        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default GurugramPage;
